import React from 'react';
import moment from 'moment';
import GraphLoader from './GraphLoader';

// Har parameter ke liye "normal / abnormal" decide karne ka logic.
const isNormal = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') {
        return value.toUpperCase() === 'ON';
    }
    if (typeof value === 'number') {
        return value > 0;
    }
    return false;
};

// Raw time "20260806T183812,455" ko readable banata hai -> "06/08/2026 18:38:12"
const formatTime = (rawTime) => {
    if (!rawTime) return '';
    const m = moment(rawTime, 'YYYYMMDDTHHmmss,SSS');
    return m.isValid() ? m.format('DD/MM/YYYY HH:mm:ss') : rawTime;
};

const CircuitPage = ({ circuit }) => {
    if (!circuit || circuit.length === 0) {
        return <GraphLoader />;
    }

    return (
        <div className="row">
            {circuit.map((asset, index) => (
                <div key={index} className="col-md-12 mb-3">
                    <div
                        style={{
                            border: '1px solid #ddd',
                            borderRadius: '6px',
                            padding: '15px',
                        }}>
                        <h6 style={{ marginBottom: '10px' }}>Asset Number : {asset.assetNumber}</h6>

                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '10px',
                            }}>
                            {asset.parameters.map((param, i) => {
                                const value = param.prv;
                                const time = formatTime(param.prt);
                                const ok = isNormal(value);

                                return (
                                    <div
                                        key={i}
                                        title={param.name}
                                        style={{
                                            width: '160px',
                                            minHeight: '100px',
                                            border: '2px solid #000',
                                            borderRadius: '6px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            background: ok ? '#0acf97' : '#fa5c7c',
                                            color: '#fff',
                                            fontWeight: '600',
                                            padding: '8px',
                                            textAlign: 'center',
                                            overflow: 'hidden',
                                            boxSizing: 'border-box',
                                        }}>
                                        <div
                                            style={{
                                                fontSize: '11px',
                                                wordBreak: 'break-word',
                                                overflowWrap: 'break-word',
                                                whiteSpace: 'normal',
                                                lineHeight: '1.3',
                                                maxWidth: '100%',
                                            }}>
                                            {param.name.replace(/_/g, ' ').toUpperCase()}
                                        </div>

                                        <div style={{ fontSize: '14px', marginTop: '4px' }}>
                                            {value !== undefined && value !== null ? value.toString() : '--'}
                                        </div>

                                        <div style={{ fontSize: '10px', marginTop: '4px', opacity: 0.85 }}>
                                            {ok ? 'OK' : 'FAULT'}
                                        </div>

                                        {time && (
                                            <div
                                                style={{
                                                    fontSize: '9px',
                                                    marginTop: '2px',
                                                    opacity: 0.75,
                                                    wordBreak: 'break-word',
                                                }}>
                                                {time}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CircuitPage;
